import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tabs, Button } from 'antd'
import { Chart, LineAdvance } from 'bizcharts';
import { req_single_cms_learnmap_ucan_commoccupation, req_single_cms_learnmap_ucan_commoccupation_details, req_single_cms_learnmap_ucan_commoccupation_modals, req_single_ucan_token_get } from '../../api'
import { ORG_CODE } from '../../utils/contrains'

const { TabPane } = Tabs
class CoursemapStudentUcanCommOccupation extends Component {
    // 基礎通用參數 //////////////////////////////////////////////  
    state = {
        items: [],
        deviceWidth: 0,
        loading: false,
        tabledata: [],
        chartdata: [],
        tablemodalsdata: [],
        ssourl: null
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize.bind(this))
        this.resize()
        this.api_init_items()
        this.ucan_sso_process()
    }

    // componentWillUnmount() {
    //     window.removeEventListener("resize", this.resize.bind(this))
    // }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_init_items = async () => {
        const { userCode, token } = this.props.user

        this.setState({ loading: true, items: [] })
        const result = await req_single_cms_learnmap_ucan_commoccupation(userCode, token)


        if (result.total > 0) {
            //console.log('commoccupationresult', result.data);
            const items = result.data;
            const { finished_date } = items[0]
            this.setState({ items, defaultDate: finished_date })
            this.tab_change(finished_date)
        } else {
            this.setState({ loading: false })
        }

    }


    // 數據格式處理 //////////////////////////////////////////////
    ucan_sso_process = async () => {
        const originalUrl = "https://ucan.moe.edu.tw/diagnosis/diagnosis_1.aspx"
        const { userCode } = this.props.user
        const key = ORG_CODE + userCode.replace(/\s+/g, '').toUpperCase()
        const token = await req_single_ucan_token_get(ORG_CODE, key) 
        const ssourl = token === 'NA' ? originalUrl : 'https://ucan.moe.edu.tw/bin/index.php?Plugin=o_hdu&Action=ohduschoolssologin&username=' + key + '&school=' + ORG_CODE + '&token=' + token
        this.setState({ ssourl })
    }

    // 介面互動處理 //////////////////////////////////////////////

    tab_change = async (key) => {
        this.setState({ tabledata: [], chartdata: [] })
        const { userCode, token } = this.props.user
        const chart = await req_single_cms_learnmap_ucan_commoccupation_details(userCode, key, token)
        if (chart.total > 0) {
            //console.log('chart', chart.data);
            const tabledata = chart.data
            const chartdata = []
            tabledata.forEach((d, idx) => {
                const name = d.brief
                chartdata.push({ label: name, tag: '測驗結果', value: d.number_score, })
                chartdata.push({ label: name, tag: '基本水準', value: 3, })
            })
            this.setState({ tabledata, chartdata })
        }

        const modalstable = await req_single_cms_learnmap_ucan_commoccupation_modals(userCode, key, token)
        if (modalstable.total > 0) {
            const tablemodalsdata = modalstable.data
            this.setState({ tablemodalsdata })
        }
        this.setState({ loading: false })
    }

    /////////////////////////////////////////////////////////////    
    render() {
        const { loading, items, defaultDate, chartdata, tabledata, tablemodalsdata, deviceWidth, ssourl } = this.state
        // 沒數據

        const originalUrl = ssourl
        const notest = (<div className="alert alert-danger"><a href={originalUrl} target="_blank" className="btn btn-mdanger" rel="noreferrer" role="button"> <Button type="primary" shape="round" size="small"> 按我 <i className="fas fa-mouse-pointer" style={{ marginLeft: '4px' }}></i></Button>  測測你的通識能力 (註：今日測驗/明日解析)</a></div>)
        // 有數據
        const th_ = tabledata.length > 0 ? tabledata.map((d, idx) => <>
            < th className="text-center" style={{ backgroundColor: 'DarkSlateBlue', color: 'white' }} key={idx}>
                <span title={d.recordDescription} key={idx}>{d.brief}</span>
            </th>
        </>) : ''
        const td_00 = tabledata.length > 0 ? tabledata.map((d, idx) => <>
            <td className="text-center" key={idx} style={{ backgroundColor: 'Pink' }}>
                <span key={idx}>{d.number_score}</span>
            </td>
        </>) : ''

        // 學制常模
        const td_01 = tabledata.length > 0 ? tabledata.map((d, idx) => <>
            < td className="text-center" key={idx}>
                <span key={idx}>{d.pr_score_01}</span>
            </td>
        </>) : ''
        const td_02 = tabledata.length > 0 ? tabledata.map((d, idx) => <>
            < td className="text-center" key={idx}>
                <span key={idx}>{d.pr_score_02}</span>
            </td>
        </>) : ''
        const td_03 = tabledata.length > 0 ? tabledata.map((d, idx) => <>
            < td className="text-center" key={idx}>
                <span key={idx}>{d.pr_score_03}</span>
            </td>
        </>) : ''
        const td_04 = tabledata.length > 0 ? tabledata.map((d, idx) => <>
            < td className="text-center" key={idx}>
                <span key={idx}>{d.pr_score_04}</span>
            </td>
        </>) : ''
        const td_05 = tabledata.length > 0 ? tabledata.map((d, idx) => <>
            < td className="text-center" key={idx}>
                <span key={idx}>{d.pr_score_05}</span>
            </td>
        </>) : ''
        const td_06 = tabledata.length > 0 ? tabledata.map((d, idx) => <>
            < td className="text-center" key={idx}>
                <span key={idx}>{d.pr_score_06}</span>
            </td>
        </>) : ''
        const td_07 = tabledata.length > 0 ? tabledata.map((d, idx) => <>
            < td className="text-center" key={idx}>
                <span key={idx}>{d.pr_score_07}</span>
            </td>
        </>) : ''
        const td_08 = tabledata.length > 0 ? tabledata.map((d, idx) => <>
            < td className="text-center" key={idx}>
                <span key={idx}>{d.pr_score_08}</span>
            </td>
        </>) : ''

        // 區域常模
        const td_10 = tablemodalsdata.length > 0 ? tablemodalsdata.map((d, idx) => <>
            < td className="text-center" key={idx}>
                <span key={idx}>{d.pr_score_02}</span>
            </td>
        </>) : ''
        const td_11 = tablemodalsdata.length > 0 ? tablemodalsdata.map((d, idx) => <>
            < td className="text-center" key={idx}>
                <span key={idx}>{d.pr_score_03}</span>
            </td>
        </>) : ''
        const td_12 = tablemodalsdata.length > 0 ? tablemodalsdata.map((d, idx) => <>
            < td className="text-center" key={idx}>
                <span key={idx}>{d.pr_score_04}</span>
            </td>
        </>) : ''
        const td_13 = tablemodalsdata.length > 0 ? tablemodalsdata.map((d, idx) => <>
            < td className="text-center" key={idx}>
                <span key={idx}>{d.pr_score_05}</span>
            </td>
        </>) : ''
        const td_14 = tablemodalsdata.length > 0 ? tablemodalsdata.map((d, idx) => <>
            < td className="text-center" key={idx}>
                <span key={idx}>{d.pr_score_06}</span>
            </td>
        </>) : ''
        const cols = {
            sales: {
                tickInterval: 0.5,
                max: 5,
                min: 0
            }
        };
        const tabPanes = items.length > 0 ? items.map((d, idx) => <TabPane tab={d.finished_date} key={d.finished_date}></TabPane>) : ''
        const descriptionhasdata = (<>
            <div>
                <div className="panel-heading">
                    <h4>分數說明如下：</h4>
                </div>
                <div className="panel-body">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th className="col-md-3 text-center" style={{ backgroundColor: 'DarkSlateBlue', color: 'white' }}>分數級距</th>
                                <th className="col-md-9 text-center" style={{ backgroundColor: 'DarkSlateBlue', color: 'white' }}>相關說明</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center">
                                    <span>1-2</span>
                                </td>
                                <td>
                                    <span>這項能力還需要特別加強，才能勝任這項工作。</span>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-center">
                                    <span>2-3</span>
                                </td>
                                <td>
                                    <span>這項能力已經有些基礎，有潛力勝任相關工作。</span>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-center">
                                    <span>3-4</span>
                                </td>
                                <td >
                                    <span>這項能力程度不錯喔。建議就繼續加強深化，就可以完全勝任這項工作。</span>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-center">
                                    <span>4以上</span>
                                </td>
                                <td>
                                    <span>這項能力是你可以發揮的優勢，建議你未來再工作要充分展現喔!</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>)

        return (
            <>
                {loading ? (<div className='text-center'>
                    <p />
                    <button className="btn " type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '4px' }}></span>
                        Loading...
                    </button>
                </div>) : (<>
                    {items.length > 0 ? (<>
                        <a className="btn btn-primary" href={originalUrl} target="_blank" rel="noreferrer" >前往UCAN平台測驗 <i className="fas fa-arrow-circle-right"></i> </a>
                        <Tabs defaultActiveKey={defaultDate} onChange={this.tab_change}>
                            {tabPanes}
                        </Tabs>
                        <div className="row" >
                            <div className="col-sm col-md-6" >
                                {deviceWidth > 700 ? (
                                    <Tabs type="card">
                                        <TabPane tab="學制常模" key="1">
                                            <table className="table table-bordered" >
                                                <thead>
                                                    <th className="text-center" style={{ textwrap: 'none' }}></th>
                                                    {th_}
                                                </thead>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'Violet' }}>原始分數</td>
                                                    {td_00}
                                                </tr>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'LightSteelBlue' }}>國立學校</td>
                                                    {td_07}
                                                </tr>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'LightSteelBlue' }}>私立學校</td>
                                                    {td_08}
                                                </tr>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'LightSteelBlue' }}>國立大學</td>
                                                    {td_01}
                                                </tr>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'LightSteelBlue' }}>私立大學</td>
                                                    {td_02}
                                                </tr>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'LightSteelBlue' }}>國立技職</td>
                                                    {td_03}
                                                </tr>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'LightSteelBlue' }}>私立技職</td>
                                                    {td_04}
                                                </tr>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'LightSteelBlue' }}>大學學制</td>
                                                    {td_05}
                                                </tr>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'LightSteelBlue' }}>技職學制</td>
                                                    {td_06}
                                                </tr>
                                            </table>
                                        </TabPane>
                                        <TabPane tab="區域常模" key="2">
                                            <table className="table table-bordered" >
                                                <thead>
                                                    <th className="text-center" style={{ textwrap: 'none' }}></th>
                                                    {th_}
                                                </thead>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'Violet' }}>原始分數</td>
                                                    {td_00}
                                                </tr>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'LightSteelBlue' }}>北部地區</td>
                                                    {td_10}
                                                </tr>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'LightSteelBlue' }}>中部地區</td>
                                                    {td_11}
                                                </tr>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'LightSteelBlue' }}>南部地區</td>
                                                    {td_12}
                                                </tr>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'LightSteelBlue' }}>東部地區</td>
                                                    {td_13}
                                                </tr>
                                                <tr>
                                                    <td className="text-center" style={{ textWrap: 'text-wrap:normal', backgroundColor: 'LightSteelBlue' }}>外島地區</td>
                                                    {td_14}
                                                </tr>
                                            </table>
                                        </TabPane>
                                    </Tabs>
                                ) : ''}
                            </div>
                            <div className="col-sm col-md-6" >
                                <Chart padding={[10, 20, 50, 40]} autoFit height={300} data={chartdata} scale={cols} >
                                    <LineAdvance
                                        shape="smooth"
                                        point
                                        area
                                        position="label*value"
                                        color="tag"
                                    />
                                </Chart>
                                {descriptionhasdata}
                            </div>
                        </div>
                    </>) : (<>
                        {notest}
                    </>)}
                </>)}
            </>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(CoursemapStudentUcanCommOccupation)